import { createAction, createSlice } from "@reduxjs/toolkit";

const initialState = {
  userReview: null,
  prevReview: null,
  processing: false,
  isSuccess: null,
};

const checkUserReviewSlice = createSlice({
  name: "checkUserReview",
  initialState,
  reducers: {
    pending(state) {
      state.processing = true;
      state.isSuccess = null;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.processing = false;
      state.isSuccess = true;
      state.userReview = action.payload.data;
      state.prevReview = action.payload.data;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.processing = false;
      state.isSuccess = false;
      state.userReview = null;
      /* TODO: reducer for failure*/
    },
    updateUserReview(state, action) {
      return {
        ...state,
        processing: false,
        userReview: { ...state.userReview, ...action.payload },
      };
    },
    updatePrevReview(state, action) {
      return {
        ...state,
        processing: false,
        prevReview: { ...state.prevReview, ...action.payload },
      };
    },
    reset(state) {
      return initialState;
    },
  },
});

const { name, actions, reducer } = checkUserReviewSlice;
const checkUserReviewAction = createAction(name);

export {
  checkUserReviewAction,
  actions as checkUserReviewActions,
  reducer as checkUserReviewReducer,
};
